import { Link, useLocation, useNavigate } from "react-router-dom";
import { Instagram, Youtube, Twitter, Facebook } from "lucide-react";

export default function Footer() {
  const location = useLocation();
  const navigate = useNavigate();

  function goToSection(hash) {
    return (e) => {
      e.preventDefault();
      if (location.pathname === "/") {
        const el = document.querySelector(hash);
        if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 80, behavior: "smooth" });
      } else {
        navigate(`/${hash}`);
      }
    };
  }

  const SectionLink = ({ hash, children }) => (
    <a href={`/${hash}`} onClick={goToSection(hash)} className="hover:text-white">{children}</a>
  );

  return (
    <footer className="relative py-16 bg-[#080810] border-t border-white/5" data-testid="footer">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 grid sm:grid-cols-2 md:grid-cols-5 gap-10">
        <div className="sm:col-span-2 md:col-span-2">
          <div className="flex items-center gap-2.5">
            <img src="/logo.svg" alt="CaarSaarthi" className="w-8 h-8 rounded-full" />
            <span className="font-serif text-2xl text-white tracking-tight">CaarSaarthi</span>
          </div>
          <p className="mt-4 text-silver/60 text-sm max-w-md leading-relaxed">
            Your Saarthi. Never Theirs. India's first buyer-side car price negotiation consultancy.
          </p>
          <div className="mt-6 flex gap-3">
            {[
              { Icon: Instagram, label: "Instagram" },
              { Icon: Youtube, label: "YouTube" },
              { Icon: Twitter, label: "X" },
              { Icon: Facebook, label: "Facebook" },
            ].map(({ Icon, label }) => (
              <a
                key={label}
                href="#"
                onClick={(e) => e.preventDefault()}
                className="w-10 h-10 grid place-items-center rounded-full border border-white/10 text-silver/70 hover:text-white hover:border-white/30 transition-colors"
                data-testid={`social-${label.toLowerCase()}`}
              >
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>
        <div>
          <p className="eyebrow gradient-text">Services</p>
          <ul className="mt-5 space-y-3 text-sm text-silver/70">
            <li><SectionLink hash="#tiers">Drona — Choose</SectionLink></li>
            <li><SectionLink hash="#tiers">Arjuna — Negotiate</SectionLink></li>
            <li><SectionLink hash="#tiers">Bhishma — Protect</SectionLink></li>
            <li><SectionLink hash="#pdi">PDI Toolkit</SectionLink></li>
            <li><a href="mailto:sales@caarsaarthi.com" className="hover:text-white">Email Sales</a></li>
          </ul>
        </div>
        <div>
          <p className="eyebrow gradient-text">Company</p>
          <ul className="mt-5 space-y-3 text-sm text-silver/70">
            <li><SectionLink hash="#story">About / Founder</SectionLink></li>
            <li><SectionLink hash="#faq">FAQ</SectionLink></li>
            <li><a href="mailto:hello@caarsaarthi.com" className="hover:text-white">Contact</a></li>
            <li><Link to="/review" className="hover:text-white">Leave a Review</Link></li>
          </ul>
        </div>
        <div>
          <p className="eyebrow gradient-text">Resources</p>
          <ul className="mt-5 space-y-3 text-sm text-silver/70">
            <li><SectionLink hash="#checklist">Buying Checklist</SectionLink></li>
            <li><SectionLink hash="#calculator">Savings Calculator</SectionLink></li>
            <li><SectionLink hash="#cases">Real Deals</SectionLink></li>
          </ul>
        </div>
      </div>
      <div className="mt-12 pt-6 border-t border-white/5 max-w-[1400px] mx-auto px-5 md:px-10 flex flex-col md:flex-row justify-between text-xs text-silver/40 gap-3">
        <div className="flex flex-wrap gap-x-5 gap-y-2 items-center">
          <a href="#" onClick={(e) => e.preventDefault()} className="hover:text-white">Terms</a>
          <a href="#" onClick={(e) => e.preventDefault()} className="hover:text-white">Privacy Policy</a>
          <a href="#" onClick={(e) => e.preventDefault()} className="hover:text-white">Refund / Cancellation</a>
          <a href="#" onClick={(e) => e.preventDefault()} className="hover:text-white">Disclaimer</a>
          <span className="text-silver/20">·</span>
          <a href="mailto:complaints@caarsaarthi.com" className="hover:text-white">Grievance: complaints@caarsaarthi.com</a>
        </div>
        <span>© {new Date().getFullYear()} CaarSaarthi. All rights reserved. Handcrafted in India · Working only for the buyer.</span>
      </div>
    </footer>
  );
}
